/* eslint-disable @typescript-eslint/no-empty-function */
import React, { FC } from 'react'
import Modal from '../Modal'
import Button from '../Button'
import { colour } from '../Icon/types'
import styles from '@bt-react/styles'
import { ConfirmModalProps } from './types'
import classnames from 'classnames'
import style from './ConfirmModal.module.scss'

const ConfirmModal: FC<ConfirmModalProps> = ({ onCancel = () => {}, onConfirm = () => {}, isOpen = false, content, className, footerItems, type = 'default' }) => {

  if (typeof content === 'undefined') {

    onCancel()
    return null

  }

  const { header, body, confirm, confirmClassName, confirmBkgColour = colour.primary, cancel = 'Cancel' } = content

  return <Modal
    concise={true}
    isOpen={isOpen}
    hideBorder={true}
    className={className}
  >
    <Modal.Header
      dataBdd={`dialog-confirm-header`}
      hideBorder={true}
      headerTitleClass={classnames({
        [style['ConfirmModal-Warning-Header']]: type === 'warning'
      })}
      headerClasses={classnames({
        [style['ConfirmModal-Warning-Header']]: type === 'warning'
      })}
    >
      {header}
    </Modal.Header>
    <Modal.Body
      dataBdd={`dialog-confirm-body`}
    >
      {body}
    </Modal.Body>
    <Modal.Footer>
      <Button
        color={confirmBkgColour}
        text={confirm}
        dataBdd="dialog-button-confirm"
        onClick={onConfirm}
        className={confirmClassName}
      />
      <Button
        color={colour.link}
        text={cancel}
        dataBdd="dialog-button-cancel"
        onClick={onCancel}
        className={styles[`text-primary-bt`]}
      />
      {footerItems}
    </Modal.Footer>
  </Modal>

}

export default ConfirmModal
